import React from "react";

export function createdCode() {
  const len = 4;
  const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789";
  const charsLen = chars.length;
  let list = []
  for (let i = 0; i < len; i++) {
      const rgb = [
          Math.round(Math.random() * 220),
          Math.round(Math.random() * 240),
          Math.round(Math.random() * 200)
      ];
      list.push({
          code: chars.charAt(Math.floor(Math.random() * charsLen)),
          color: `rgb(${rgb})`,
          fontSize: `${
              10 + (+[Math.floor(Math.random() * 10)] + 6)
          }px`,
          transform: `rotate(${
              Math.floor(Math.random() * 90) -
              Math.floor(Math.random() * 90)
          }deg)`
      });
  }

  return list;
}

const App = ({codeList, onCodeListUpdate}) => {

  const getStyle = (data) => {
    return {
      color: data.color,
      fontSize: data.fontSize,
      transform: data.transform
    }
  }

  const handleClick = () => {
    onCodeListUpdate && onCodeListUpdate();
  }

  return (
    <div className="dialog-valid-code" onClick={handleClick}>
      {
          codeList && codeList.map((item, index) => (
            <span key={index} style={getStyle(item)}>{item.code}</span>
          ))
      }
    </div>
  );
};

export default App;
